var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('VideoInBrowser',{attrs:{"leaving":_vm.leaving},on:{"waitBeforeLeaving":_vm.handleWaitBeforeLeaving}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }